import { Document } from "@/tools/msa/models";
import { ConceptType } from "@/utils/analysis";
import { ConceptMatch } from "@/tools/msa/models/concepts";
import { ConceptMatchItem } from "@/tools/msa/models/item";

export const getNames = (
  document: Document,
  conceptId: string,
  filters: Array<(match: ConceptMatch) => Boolean> = []
) =>
  document.items
    .filter(item => item.type === "concept_match")
    .map(item => (item as ConceptMatchItem).match as ConceptMatch)
    .filter(match => match.concept.type === ConceptType.Name)
    .filter(match => match.concept.id === conceptId)
    .map(
      match =>
        [
          match,
          filters.map(filter => filter(match)).filter(Boolean).length
        ] as [ConceptMatch, number]
    )
    .sort((a, b) => b[1] - a[1])
    .map(([match]) => match.text);
